
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function CreditGuaranteePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-indigo-50 via-white to-purple-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <Link to="/" className="text-gray-500 hover:text-indigo-500 transition-colors">
              <i className="ri-home-line"></i>
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/services" className="text-gray-500 hover:text-indigo-500 transition-colors">
              服務方案
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-indigo-600 font-medium">信保基金專案</span>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block bg-indigo-600 text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
                <i className="ri-shield-check-line mr-2"></i>中小企業
              </span>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                信保基金專案
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                透過中小企業信用保證基金提供信用保證，協助企業解決擔保品不足問題，順利取得銀行融資。
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  className="px-8 py-4 bg-gradient-to-r from-indigo-500 to-indigo-600 text-white rounded-lg font-semibold hover:from-indigo-600 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  立即諮詢此方案
                </Link>
                <a
                  href="https://line.me/R/ti/p/@678gwbht"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-[#06C755] text-white rounded-lg font-semibold hover:bg-[#05b34c] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-line-fill text-xl"></i>
                  LINE 諮詢
                </a>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/bf9f08b2688058de0a5a110f1562d248.jpg"
                alt="信保基金"
                className="w-full h-[400px] object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 專案概述 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">專案概述</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              信保基金，全名為中小企業信用保證基金，是一項由政府支持設立的政策性金融機制，主要功能在於協助中小企業強化融資信用條件，提升銀行核貸意願與成功率。
            </p>
            <p className="text-lg">
              自 1974 年成立以來，信保基金已累計協助超過 240 萬戶以上之中小企業及勞工，承保件數逾 1,100 萬件，協助取得融資金額超過 27 兆元，累計保證金額達 20 兆元以上，為國內中小企業融資體系之核心支撐機制。
            </p>
            <p className="text-lg">
              信保基金本身並非放款機構，而是透過「信用保證」的方式，協助銀行分擔部分授信風險，讓具備發展潛力的企業能更順利取得營運資金或成長所需資源。
            </p>
          </div>
        </div>
      </section>

      {/* 適用場景與制度設計 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">適用場景與制度設計</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed mb-12">
            <p className="text-lg">
              當銀行對企業風險評估較為保守時，信保基金可由政府出面提供部分還款保證，協助貸款順利成立。
            </p>
            <p className="text-lg font-semibold text-gray-900">
              信保基金實際運作方式如下：
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-bank-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">資金來源</h3>
              <p className="text-gray-600 leading-relaxed">
                貸款資金仍由合作銀行提供，信保基金不直接放款
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">信用支持</h3>
              <p className="text-gray-600 leading-relaxed">
                由信保基金對銀行提供一定比例的信用保證（最高可擔保九成）
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-scales-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">風險分擔</h3>
              <p className="text-gray-600 leading-relaxed">
                若發生不可預期之還款風險，信保基金依保證範圍協助銀行分攤風險
              </p>
            </div>
          </div>

          <div className="max-w-5xl mx-auto mt-8">
            <p className="text-lg text-gray-700 leading-relaxed text-center">
              簡言之，這是一套降低銀行風險、提升企業融資可行性的制度設計。
            </p>
          </div>
        </div>
      </section>

      {/* 為什麼銀行願意配合 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">為什麼銀行願意配合</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg font-semibold text-gray-900">
              在銀行的風險管理架構中：
            </p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-lg">信保機制可有效降低授信風險權重</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-lg">提升放款彈性與核准空間</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-lg">讓原本條件尚未完全成熟的企業，也能在合規前提下取得資金支持</span>
              </li>
            </ul>
            <p className="text-lg mt-6">
              對銀行而言，信保基金是兼顧風控與業務推動的重要輔助工具。
            </p>
          </div>
        </div>
      </section>

      {/* 適合運用信保機制的企業 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">適合運用信保機制的企業</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed mb-8">
            <p className="text-lg font-semibold text-gray-900">
              特別適合下列企業類型：
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">新創或成長型企業</h3>
              <p className="text-gray-600 leading-relaxed">
                成立時間較短的新創或成長型企業
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-building-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">擔保品有限</h3>
              <p className="text-gray-600 leading-relaxed">
                擔保品有限、資本額仍在擴張階段
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-3xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">財報累積中</h3>
              <p className="text-gray-600 leading-relaxed">
                財報仍在累積中，但營運模式清楚、現金流具合理說明的企業
              </p>
            </div>
          </div>

          <div className="max-w-5xl mx-auto mt-8">
            <p className="text-lg text-gray-700 leading-relaxed text-center">
              本質上，信保基金是協助企業跨越成長初期門檻的過渡性金融支持方案。
            </p>
          </div>
        </div>
      </section>

      {/* 小提醒：信保不等於保證核貸 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">小提醒：信保不等於保證核貸</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-8">
              <div className="flex items-start mb-6">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-error-warning-line text-2xl text-amber-600"></i>
                </div>
                <div>
                  <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    信保基金並非「自動過件」機制，銀行仍會依既有授信流程進行審查，包括：
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 text-xl mt-0.5 mr-2 flex-shrink-0"></i>
                      <span className="text-gray-700">負責人信用狀況</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 text-xl mt-0.5 mr-2 flex-shrink-0"></i>
                      <span className="text-gray-700">企業營運與現金流表現</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-amber-600 text-xl mt-0.5 mr-2 flex-shrink-0"></i>
                      <span className="text-gray-700">產業屬性與整體風險評估</span>
                    </li>
                  </ul>
                  <p className="text-lg text-gray-700 leading-relaxed mt-6">
                    信保基金的角色在於提升可行性、降低阻力，而非取代銀行的授信判斷。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 適用對象 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">適用對象</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed mb-8">
            <p className="text-lg">
              信保基金之信用保證服務，主要協助各類具營運實體之企業與創業者，包含但不限於：
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            <div className="bg-white rounded-xl p-6 border border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-2-line text-xl text-indigo-600"></i>
                </div>
                <span className="text-gray-900 font-semibold">中小企業</span>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-4-line text-xl text-indigo-600"></i>
                </div>
                <span className="text-gray-900 font-semibold">非中小企業（符合特定專案或政策條件者）</span>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-2-line text-xl text-indigo-600"></i>
                </div>
                <span className="text-gray-900 font-semibold">小規模商業</span>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-indigo-100 hover:border-indigo-300 transition-all">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-xl text-indigo-600"></i>
                </div>
                <span className="text-gray-900 font-semibold">創業及新創事業</span>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-indigo-100 hover:border-indigo-300 transition-all md:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-briefcase-line text-xl text-indigo-600"></i>
                </div>
                <span className="text-gray-900 font-semibold">其他經主管機關認定之企業或營運主體</span>
              </div>
            </div>
          </div>

          <div className="max-w-5xl mx-auto mt-8">
            <p className="text-lg text-gray-700 leading-relaxed text-center">
              透過信用保證機制，協助企業在融資條件尚未完全成熟階段，仍可順利銜接銀行資金。
            </p>
          </div>
        </div>
      </section>

      {/* 信保基金貸款用途範圍 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">信保基金貸款用途範圍</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed mb-8">
            <p className="text-lg">
              信保基金所提供之信用保證，可廣泛運用於下列合法且具經營合理性之資金需求：
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            <div className="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-6 border border-indigo-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-refresh-line text-xl text-indigo-600"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-semibold mb-1">營運週轉金</h3>
                  <p className="text-sm text-gray-600">日常營運資金調度</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-6 border border-indigo-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-line text-xl text-indigo-600"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-semibold mb-1">資本性支出</h3>
                  <p className="text-sm text-gray-600">設備、廠房、系統建置等</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-6 border border-indigo-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-ship-line text-xl text-indigo-600"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-semibold mb-1">進出口貿易融資</h3>
                  <p className="text-sm text-gray-600">國際貿易資金需求</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-6 border border-indigo-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-rocket-line text-xl text-indigo-600"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-semibold mb-1">創業準備金</h3>
                  <p className="text-sm text-gray-600">創業初期資金支持</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-6 border border-indigo-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-shield-line text-xl text-indigo-600"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-semibold mb-1">履約保證需求</h3>
                  <p className="text-sm text-gray-600">合約履約保證金</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-white rounded-xl p-6 border border-indigo-100">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-home-gear-line text-xl text-indigo-600"></i>
                </div>
                <div>
                  <h3 className="text-gray-900 font-semibold mb-1">災後復舊與重建</h3>
                  <p className="text-sm text-gray-600">天然災害後之資金需求</p>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-5xl mx-auto mt-8">
            <p className="text-lg text-gray-700 leading-relaxed text-center">
              協助企業因應成長、轉型、突發事件或市場擴張所需之資金調度。
            </p>
          </div>
        </div>
      </section>

      {/* 近期重點推動保證方向 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">近期重點推動保證方向（摘要）</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-indigo-500 to-indigo-600 mx-auto"></div>
          </div>

          <div className="max-w-5xl mx-auto space-y-6 text-gray-700 leading-relaxed mb-8">
            <p className="text-lg">
              目前信保基金主要推動之重點方向包含：
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* 一般及專案保證措施 */}
            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-list-3-line text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">一般及專案保證措施</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">中小企業發展專案保證</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">子企業／小額貸款專屬保證措施</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">中小微企業多元發展與轉型信用保證</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">新創企業與青年創業專案</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">外銷貸款與國際貿易相關信用保證</span>
                </li>
              </ul>
            </div>

            {/* 政策型與專區型保證方案 */}
            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-government-line text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">政策型與專區型保證方案</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">因應關稅與國際經貿變動專區</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">天災復舊專區</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">新創企業及直接保證方案</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">配合銀行公會及政府部會推動之專案融資保證</span>
                </li>
              </ul>
            </div>

            {/* 配套與彈性措施 */}
            <div className="bg-white rounded-2xl p-8 border-2 border-indigo-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-3-line text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">配套與彈性措施</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">保證條件與額度彈性化設計</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">協助降低銀行授信風險</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">支援企業於特定期間或特殊情境下之資金需求</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-indigo-500 to-indigo-600">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            缺乏擔保品？讓信保基金助您一臂之力
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            朋睿專業顧問協助您評估資格、準備完整文件，提高信保核准率
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-white text-indigo-600 text-lg font-semibold rounded-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              免費諮詢
            </Link>
            <Link
              to="/services"
              className="px-8 py-4 bg-transparent text-white text-lg font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              查看其他方案
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
